import _sfc_main from "./BuyBoxPrice2.mjs";
/* empty css              */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxPrice = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-ac845d27"]]);
export {
  BuyBoxPrice as default
};
//# sourceMappingURL=BuyBoxPrice.mjs.map
